module.exports = __webpack_public_path__ + "img/logo_9.a07f0c71.jpg";